import { useQuery } from "@tanstack/react-query";
import uuidV4 from "uuid/v4";

const baseURL = process.env.REACT_APP_API_URL;
const instanceId = process.env.REACT_APP_INSTANCE_ID;

const routeURL =
  "https://dtdl-static-natco.eshop.yo-digital.com/assets/dtdl/174956510591328_paths.json";

const jobRequestBody = {
  Skip: 0,
  Top: 10,
  SortBy: "None",
  Filters: {},
  GetFiltersData: true,
};
const jobAPIHeaders = {
  "Content-Type": "application/json",
  "x-api-key": "B337711D-39F7-4E81-9635-ADC0F156B689",
};

const fetchJobData = async () => {
  const response = await fetch(
    `https://api.turbohire.co/api/v2/careerpagejobs`,
    {
      method: "POST",
      headers: jobAPIHeaders,
      body: JSON.stringify(jobRequestBody),
    }
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

// Function to fetch site data
const fetchSiteData = async (slug: string) => {
  const response = await fetch(
    `${baseURL}/api/pageBuilder/slugs/${instanceId}/${slug}`
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const subscribe = async (payload: object, formId: string) => {
  const response = await fetch(`${baseURL}/api/pageBuilder/forms/submissions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      formId: formId,
      origin: window.location.origin,
      "x-request-tracking-id": uuidV4(),
    },
    body: JSON.stringify({
      formData: JSON.stringify(payload),
      triggerEmail: true,
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to subscribe");
  }

  return response.json();
};

// Custom hook to fetch and cache data using React Query
export const useCustomSiteQuery = (
  slug: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["siteData", slug], // Ensures unique caching based on slug
    queryFn: () => fetchSiteData(slug), // Fetch function
    staleTime: Infinity, // Cache the data indefinitely
    enabled: options?.enabled ?? true,
  });
};

export const useCustomJobQuery = () => {
  return useQuery({
    queryKey: ["jobData"], // Ensures unique caching based on slug
    queryFn: () => fetchJobData(), // Fetch function
    staleTime: Infinity, // Cache the data indefinitely
    retry: 3,
  });
};

export const fetchRoutesData = async () => {
  try {
    // todo need to be changed in next  prod build  in MArch 2025
    // const response = await fetch(process.env.REACT_APP_ROUTES || routeURL);
    const response = await fetch(routeURL);

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching JSON:", error);
  }
};
